import { PaymentType } from './Order';

export interface DailyReport {
  deliveries: {
    counts: Counts;
    payments: Payments;
  }
  pickups: {
    counts: Counts;
  }
  drivers: Driver[];
  orders: DailyReportOrder[];
}

export interface Counts {
  canceled: OrderIds;
  complete: OrderIds;
  scheduled: OrderIds;
}

export interface OrderIds {
  total: number;
  ids: string[];
}

export type Payments = {
  [key in PaymentType]: OrderIds;
}

export interface Driver {
  id: string;
  name: string;
  onClock: number;
  status: DriverStatus;
}

export enum DriverStatus {
  IN_PROGRESS = 'in_progress',
  COMPLETE = 'complete',
  NOT_STARTED = 'not_started',
}

export const driverStatusToText: Record<DriverStatus, string> = {
  [DriverStatus.COMPLETE]: 'Complete',
  [DriverStatus.IN_PROGRESS]: 'On clock',
  [DriverStatus.NOT_STARTED]: 'Not started'
}

export interface DailyReportOrder {
  id: string;
  driverId: string;
  customerName: string;
  address: string;
  paymentType?: string;
}

export const getWorkTimeMinutes = (t: number): string => {
  const hours = Math.floor(t / 60);
  const minutes = t % 60;

  return `${hours} h ${minutes} min`;
}

export interface DailyDriverReport {
  deliveries: {
    counts: Counts;
    payments: Payments;
  }
  pickups: {
    counts: Counts;
  }
  driver: Driver;
  orders: DailyReportOrder[];
}
